<template>
  <li class="tree-node">
    <input
      :id="model.represent_id"
      v-model="checked"
      type="radio"
      name="rad"
      :value="model.represent_id"
    >
    <label
      key="label"
      class="tree-text"
    >
      <div
        :title="model.name"
        class="text-lable"
        @click="changePath"
      >
        <v-icon
          class="health-check"
          :class="[
            { on: 1 || model.check_health },
            { partly: 0 },
            { off: 0 && !model.check_health }
          ]"
        >mdi-home-variant</v-icon>
        <span
          class="item-name"
          :class="{ 'empty-item-name': !isFolder }"
        >{{ model.name }}</span>
        <span
          v-if="isFolder"
          :key="model.represent_id"
          class="item-btns v-btn v-btn--icon"
          @click.stop="toggle"
        >
          <v-icon>fas fa-caret-{{ open ? 'down' : 'right' }}</v-icon>
        </span><!--
        --><v-btn
          icon
          class="item-btns"
          :to="`/represent/${model.represent_id}/new`"
          @click="createSubRepresent=true"
        >
          <v-icon>fas fa-plus</v-icon>
        </v-btn>
      </div>

    </label>
    <div class="tree-children">
      <ul
        v-show="open"
        v-if="isFolder"
      >
        <v-treeview-item
          v-for="child in model.children"
          :key="child.represent_id"
          :model="child"
          :tree-types="treeTypes"
          :open-all="openAll"
          @addNode="addNode"
          @selected="selected"
        />
      </ul>
    </div>
  </li>
</template>

<script>
export default {
  name: 'VTreeviewItem',
  props: ['model', 'treeTypes', 'openAll'],
  data () {
    return {
      open: false,
      checked: this.$route.params.representId,
      createSubRepresent: false
    }
  },
  computed: {
    isFolder () {
      return this.model.children && this.model.children.length
    }
  },
  created () {
    this.open = this.model.children.some(x => x.represent_id === parseInt(this.checked))
  },
  watch: {
    openAll (openAll) {
      this.open = openAll
    },
    '$route' (to, from) {
      this.checked = this.$route.params.representId
    }
  },
  methods: {
    selected (node) {
      if (!this.createSubRepresent) {
        this.$emit('selected', node)
      } else {
        setTimeout(() => { this.createSubRepresent = false }, 100)
      }
    },
    addNode (newNode) {
      this.model.children.push(newNode)
    },
    toggle () {
      if (this.isFolder) {
        this.open = !this.open
      }
    },
    changePath () {
      this.selected(this)
    }
  }
}
</script>

<style scoped lang="scss">
  ul {
      display: block;
      list-style: none;
      margin: 0;
      padding: 0 0 0 4px;
  }

  ul .tree-node {
    display: block;
    padding-left: 15px;

    label:hover,
    input[type="radio"]:checked + label {
      .text-lable {
        background-color: rgba(0,0,0,.12);
      }
    }
  }
  li {
      list-style-type: none;

      font-family: sans-serif;
  }

  ul .tree-node input[type="radio"] {
      display: none;
  }

  ul label {
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
  }

  ul .tree-node input[type="radio"]:checked {

  }

  ul .tree-node {
      line-height: 1;
      position: relative;
  }

  .tree-node:before {
      content: "";
      border-bottom: 1px solid #979999;
      border-left: 1px solid #979999;
      position: absolute;
      width: 7px;
      height: 27px;
      top: -14px;
      left: 22px;
  }

  .tree-node:first-child::before {
      height: 17px;
      top: -4px;
  }

  .tree-node:after {
      content: "";
      border-left: 1px solid #979999;
      position: absolute;
      top: 13px;
      bottom: 14px;
      left: 22px;
  }

  .tree-node:last-child:after {
      content: none;
  }

  .tree-text {
      line-height: 1;
  }
  .text-lable {
    position: relative;
    left: 17px;
    width: 90%;
    white-space: nowrap;
    .health-check, .item-name {
      vertical-align: middle;
    }
  }
  .item-name {
    display: inline-block;
    max-width: calc(100% - 60px);
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .empty-item-name {
    max-width: calc(100% - 45px);
  }
  .health-check.on {

  }
  .health-check.off {
    color: #e0a6a2;
  }
  .health-check.partly {
    color: #fcf06d;
  }
  .item-btns {
    width: 15px;
    height: 15px;
    margin: 6px 0;
  }
  span.item-btns .v-icon {
    font-size: 14px;
  }
  a.item-btns .v-icon {
    font-size: 10px;
  }
  .mdi-home-variant {
    vertical-align: baseline;
    font-size: 20px;
  }
  .rep-tree>ul>li>label>div>.mdi-home-variant:before {
    content: "\F34E";
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/VTreeviewItem.vue